import './../../index.css';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import hoc from '../../hoc.js';
import 'classnames';
import '@hh.ru/magritte-common-use-disabled';
import '@hh.ru/magritte-ui-badge';
import '../../IconDynamic-BiKz7_SZ.js';
import '../../Skeleton.js';
import '@hh.ru/magritte-ui-skeleton';

const DocumentOutlinedSize16Component = (props, ref) => (jsx("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("g", { children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14 5.95453L14 15.5H2.00005L2 0.500015L8.66665 0.5C12.6667 0.5 14 1.86363 14 5.95453ZM12.6 5.95453L12.6 14.1H3.40004L3.4 1.90001L8.66665 1.9C10.5834 1.9 11.4139 2.24405 11.8323 2.67195C12.2597 3.10906 12.6 3.98116 12.6 5.95453ZM10.9972 7.03184H4.99866V5.63184H10.9972V7.03184ZM10.9972 10.3644H4.99866V8.96436H10.9972V10.3644Z", fill: "var(--magritte-ui-icon-color)" }) }) }));
const DocumentOutlinedSize16 = hoc(forwardRef(DocumentOutlinedSize16Component), 'DocumentOutlinedSize16');

export { DocumentOutlinedSize16 as default };
//# sourceMappingURL=DocumentOutlinedSize16.js.map
